var map = {
	"./All Set.svg": 378,
	"./BigCalendar.svg": 379,
	"./CalendarIcon.svg": 217,
	"./ClassesMenu.svg": 380,
	"./ClockIcon.svg": 218,
	"./Down Arrow.svg": 381,
	"./Edit.svg": 219,
	"./Frame.svg": 382,
	"./Home.svg": 383,
	"./INR.svg": 384,
	"./LaptopGirl.svg": 385,
	"./LogoutIcon.svg": 185,
	"./MyDriveIcon.svg": 386,
	"./MyScheduleIcon.svg": 387,
	"./ProfileImage.svg": 196,
	"./TV.svg": 388,
	"./Up Arrow.svg": 389,
	"./UserIcon.svg": 390,
	"./UserIcon2.svg": 391,
	"./UserIcon3.svg": 392,
	"./UserIconSolid.svg": 220,
	"./UserIconSolid2.svg": 120,
	"./Whatsapp.svg": 393,
	"./arrow_left.svg": 221,
	"./arrow_right.svg": 222,
	"./back.svg": 223,
	"./brand-icons/hotstar.png": 394,
	"./brand-icons/netflix.png": 395,
	"./brand-icons/prime-video.png": 396,
	"./brand-icons/spotify.png": 397,
	"./brand-icons/spotify_icon.svg": 224,
	"./brand-icons/youtube.png": 398,
	"./brand-icons/youtube_icon.svg": 225,
	"./brand-logos/hotstar.svg": 226,
	"./brand-logos/hotstar_logo.svg": 227,
	"./brand-logos/netflix.svg": 399,
	"./brand-logos/prime-video-logo.svg": 228,
	"./brand-logos/prime-video.svg": 229,
	"./brand-logos/spotify.svg": 400,
	"./brand-logos/spotify_brand_logo.svg": 230,
	"./brand-logos/youtube.svg": 401,
	"./brand-logos/youtube_brand_logo.svg": 231,
	"./caret-down.svg": 203,
	"./caret-up.svg": 402,
	"./chevron_right.svg": 232,
	"./clipboard.svg": 233,
	"./close-white.svg": 234,
	"./close.svg": 198,
	"./contact-us.svg": 204,
	"./cross-darkgrey.svg": 235,
	"./dance-drama.svg": 205,
	"./down-arrow-outline.svg": 199,
	"./jm_icon.svg": 206,
	"./loginScreen.svg": 403,
	"./menu.svg": 236,
	"./message.svg": 237,
	"./pdf.svg": 200,
	"./play-button.svg": 238,
	"./question.svg": 404,
	"./quotes.svg": 207,
	"./report-card.svg": 405,
	"./right-arrow.svg": 208,
	"./send.svg": 239,
	"./speech_bubble.svg": 209,
	"./tick.svg": 240,
	"./toast-error.svg": 210,
	"./toast-info.svg": 211,
	"./toast-success.svg": 212,
	"./toast-warn.svg": 213,
	"./vibe-filled-dark.svg": 201,
	"./vibe-filled.svg": 406,
	"./vibe-outline-dark.svg": 214,
	"./vibe-outline.svg": 407
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 131;